import React from "react";

import { useSelector } from "react-redux";
import Loginpage from "./Loginpage";

import PassworCheck from "./checkTempPassword";

function Mainpage() {
  const isLogin = useSelector((state) => state.Login.isLogin);

  return <div>{isLogin ? <PassworCheck /> : <Loginpage />}</div>;
}
export default Mainpage;
